<template>
    <v-dialog v-model="show_dialog" width="auto">
      <v-card>
        <v-card-text>
            <h3>Disclaimer:</h3>
            This application is intended for research purposes only. It should not be used for medical advice.<br>
            <p></p>
            Information contained on this website does not substitute clinical judgement or advice.<br>

        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" class="consent-button" block @click="giveConsent()">Accept</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script setup lang="js">
import { onMounted, ref, } from 'vue';

/**
 * If the disclaimer is loaded, the following steps are performed:
 * 1. It is checked whether a consent "token" is present in the user's localStorage
 * 2. If this is the case, the modal is instantly closed (= never shown)
 */
onMounted(() => {
    if (localStorage.getItem("onkopus_consent") && localStorage.getItem("onkopus_consent") == "accepted")
        show_dialog.value = false;
        //emit('close-modal');
})

/**
 * @emit close-modal - Tells the parent to close this modal
 */
const emit = defineEmits(['close-modal']);

/**
 * The user consents to cookies and some other stuff.
 */
const giveConsent = () => {
    localStorage.setItem("onkopus_consent", "accepted");
    show_dialog.value = false;
    //emit('close-modal');
}

const show_dialog = ref(true);
</script>

<style>

.consent-popup-background {
    background-color: rgba(211, 211, 211, 0.8);
    z-index: 30;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.consent-popup-form {
    border: solid 4px;
    border-color: rgba(211, 211, 211, 0.5);
    border-radius: 5px;
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-flow: row;
    width: fit-content;
    max-width: 20%;
    height: fit-content;
    background-color: #f3f3f3;
    min-height: 10rem;
    padding: 16px;
    box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    color: black;
}

.consent-button {
    margin-left: auto;
    margin-right: auto;
}



</style>
